import 'core-js';

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import 'normalize.css';

import VueCompositionApi from '@vue/composition-api';

// document.querySelector('#debugLog').innerText = 'main.js Starting Vue';

Vue.config.productionTip = false;
Vue.use(VueCompositionApi);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// document.querySelector('#debugLog').innerText = 'Vue mounted';

// // Import flavors
// import flavorBanana from '@/assets/flavors/flavor_banana.png';
//
// console.log('flavorBanana:', flavorBanana);

// Fixing the issue with vh where it doesn't take account of the browser bar and bottom tab.
// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);
